import { useContext, useEffect, useState } from 'react';
import { Button, PageHeader, Space } from 'antd';
import { Filters, InvoicesTable } from './components';
import { InvoicesContext } from './context/invoices.context';
import { IInvoice } from './context/invoices.interface';
import { BulkTransactionsModal } from './components/BulkTransactionsModal';
import Transactions from '../Modals/Transactions';
import MRRTransactions from '../Modals/MRRTransactions';
import NewInvoice from './components/NewInvoice';

const Invoices = ({ params }: { params: URLSearchParams }) => {
    const {
        fetchData,
        loading,
        loadingAction,
        data,
        item,
        total,
        paginator,
        onPageChange,
        searchParams,
        date,
        selectedRowKeys,
        setItem,
        setData,
        handleDate,
        handleSearch,
        handleInvoiceId,
        handleFrequency,
        handleGateway,
        handleStatus,
        handleType,
        handleNewInvoice,
        setSelectedRowKeys,
    } = useContext(InvoicesContext);

    const [showBulkTransactions, setShowBulkTransactions] = useState(false);
    const [showNewInvoice, setShowNewInvoice] = useState(false);

    useEffect(() => {
        fetchData();
    }, [params, paginator]);

    return (
        <PageHeader
            title="Invoices"
            style={{ padding: '32px 24px 24px 0' }}
            extra={[
                <Button
                    type="ghost"
                    onClick={() => setShowBulkTransactions(true)}
                >
                    Bulk transactions
                </Button>,
                <Button
                    type="primary"
                    onClick={() => setShowNewInvoice(true)}
                >
                    New invoice
                </Button>,
            ]}
            footer={(
                <Space direction="vertical" size={24} style={{ width: '100%' }}>
                    {
                        item?.type === 'BOOKING' ? (
                            <Transactions
                                invoice={item}
                                onClose={(invoice: IInvoice | null) => setItem(null)}
                            />
                        ) : (
                            <MRRTransactions
                                invoice={item}
                                onClose={(invoice: IInvoice | null) => setItem(null)}
                            />
                        )
                    }

                    <Filters
                        searchParams={searchParams}
                        date={date}
                        handleDate={handleDate}
                        handleStatus={handleStatus}
                        handleSearch={handleSearch}
                        handleFrequency={handleFrequency}
                        handleGateway={handleGateway}
                        handleInvoiceId={handleInvoiceId}
                        handleType={handleType}
                    />

                    <InvoicesTable
                        loading={loading}
                        data={data}
                        total={total}
                        paginator={paginator}
                        onPageChange={onPageChange}
                        setSelectedRowKeys={setSelectedRowKeys}
                        selectedRowKeys={selectedRowKeys}
                    />
                    {
                        showBulkTransactions && (
                            <BulkTransactionsModal
                                visible={showBulkTransactions}
                                onCancel={() => setShowBulkTransactions(false)}
                            />
                        )
                    }
                    {
                        showNewInvoice && (
                            <NewInvoice
                                visible={showNewInvoice}
                                onCancel={() => setShowNewInvoice(false)}
                                onOk={(values: any) => handleNewInvoice(values)}
                            />
                        )
                    }

                </Space>
            )}
        />
    );
};

export default Invoices;
